export const ElementLabel = ({ chakra, testid, className = "" }) => (
  <p
    data-testid={testid}
    className={`font-mono text-xs font-semibold uppercase tracking-[0.35em] ${className}`}
    style={{ color: chakra.color, textShadow: `0 0 12px ${chakra.glow}` }}
  >
    {chakra.element}
  </p>
);
